
export const GENERATED_IDS = {
    "__TALENT_ID": {
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {}
        },
        "WARRIOR": {
            "PROT": {},
            "FURY": {},
            "ARMS": {}
        },
        "ROGUE": {
            "ASS": {},
            "SUB": {},
            "OUT": {}
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {},
            "HAVOC": {}
        },
        "DRUID": {
            "GUARDIAN": {},
            "FERAL": {},
            "RESTO": {
                "INNER_PEACE": "9816f40b-2412-4616-9960-63a6551fe943",
                "TREE": "eb1dec13-e58d-4f57-96e7-668749613440"
            },
            "BALANCE": {}
        },
        "PRIEST": {
            "HOLY": {
                "SALV": "b7d741b8-7ddd-4840-b496-87969ebf28cb"
            },
            "DISC": {
                "EVANGELISM": "bae29c2a-4e98-4335-a4e1-196ba905cace",
                "SHELL": "3e09a8a9-f387-4883-a621-9d984b9ea13e",
                "MINDBENDER": "69341f1a-6471-4a2c-bf46-b17b254fee3f"
            },
            "SHADOW": {}
        },
        "DK": {
            "FROST": {},
            "UNHOLY": {},
            "BLOOD": {}
        },
        "PALADIN": {
            "RET": {},
            "PROT": {},
            "HOLY": {
                "HOLY_AVENGER": "816d8c3d-7227-4c6a-856e-7d1b4989923b",
                "CRUSADER": "a40a3036-dcbe-4962-9495-2bfe0a1bd5e5"
            }
        },
        "SHAMAN": {
            "ENH": {},
            "RESTO": {
                "ASC": "c89be67f-c5b1-4fab-a510-6593c131dd6e",
                "APT": "22efd01f-1258-42ef-9b49-836f9bd1e781",
                "WRT": "c283517a-1dfa-4a5b-acb8-5e707dd66438"
            },
            "ELE": {}
        },
        "MONK": {
            "WW": {},
            "MW": {
                "CHI_JI": "12fd7fd0-3392-45aa-ac5d-ef5a16675b6c"
            },
            "BRM": {}
        },
        "HUNTER": {
            "MM": {},
            "SV": {},
            "BM": {}
        }
    },
    "__MODIFIER_ID": {},
    "__SPELL_ID": {
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {}
        },
        "WARRIOR": {
            "PROT": {
                "RALLY": "2e624376-09f7-4ca3-bbb5-9f98c7b16adc"
            },
            "FURY": {
                "RALLY": "9a045fe3-2df8-41bc-bb49-3885af435509"
            },
            "ARMS": {
                "RALLY": "33a6e8c9-1da0-4d1e-9b4b-51f7ac55ab5c"
            }
        },
        "ROGUE": {
            "ASS": {},
            "SUB": {},
            "OUT": {}
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {},
            "HAVOC": {
                "DARK": "d587377a-5717-430f-8401-58de74f9fda8"
            }
        },
        "DRUID": {
            "GUARDIAN": {
                "ROAR": "9bc18005-3fb3-435d-9eb6-bc70ad7dcd7f"
            },
            "FERAL": {
                "ROAR": "d2acd5d9-d46f-409b-a1db-b5d5d8fdd996"
            },
            "RESTO": {
                "TRANQ": "f5893bda-6300-4815-bb54-88b5d402b6a5",
                "ROAR": "03144576-38ad-4511-81d5-755cdf3662fd",
                "TREE": "35f8b981-e772-4084-a274-d8b0fd875688"
            },
            "BALANCE": {
                "ROAR": "62704b34-f28b-4567-8bb1-25c36d930c13"
            }
        },
        "PRIEST": {
            "HOLY": {
                "HYMN": "e15425af-a973-4727-92bc-2da86297a934",
                "SALV": "39e8f6ac-1b91-41e1-9e66-354e1eece56a"
            },
            "DISC": {
                "EVANGELISM": "c99f217d-2734-423c-aaee-edc5bdb14f81",
                "SHELL": "7f8c721f-1f23-43b3-8164-dcc2f2715985",
                "FIEND": "9009c1c3-579e-4900-8cab-83f0a19a3cf9",
                "MINDBENDER": "b5b02f28-d5d7-4456-bc5b-d0e61bce57da",
                "BARRIER": "321d761a-2d39-4dff-a24d-fcb813268dce",
                "RAPTURE": "d785b1f4-4e56-48e3-af49-4f0c7c584f16"
            },
            "SHADOW": {
                "EMBRACE": "fb68bbab-23dd-4d0e-a018-cb98ed6816d9"
            }
        },
        "DK": {
            "FROST": {
                "AMZ": "c8e071c5-7241-4291-838b-1a9f7572225e"
            },
            "UNHOLY": {
                "AMZ": "a97eab84-dfcb-497a-b80c-1efc391fd726"
            },
            "BLOOD": {
                "AMZ": "5aa18ab8-1710-4a4d-bd0e-749e374b105e"
            }
        },
        "PALADIN": {
            "RET": {},
            "PROT": {},
            "HOLY": {
                "HOLY_AVENGER": "7c262290-fde4-43c7-94a9-7b9e87435965",
                "CRUSADER": "680e990b-3b4a-4d4b-9b08-c5a8f31ce59e",
                "WINGS": "46d09b2f-e027-4d72-a759-34b409049438",
                "AM": "63ad52fb-d45d-4109-883f-8bcb7f993af6"
            }
        },
        "SHAMAN": {
            "ENH": {
                "WRT": "3ac0cbc8-4887-4e69-b228-bd7a68813f88"
            },
            "RESTO": {
                "ASC": "ef87cf2e-147e-424f-af96-6cd5620175ba",
                "APT": "7559cc30-510a-4117-9510-4895c293f22d",
                "WRT": "b68e0821-b1f8-40b6-8b92-233b1f5e7f2e",
                "HTT": "11af8b5c-dc51-4b41-8ad8-4f90310e0a60",
                "SLT": "56031ab6-2269-4437-89f3-5c6ee81709fa"
            },
            "ELE": {
                "WRT": "2d2e65f5-115f-4460-86b6-f5e190d0e914"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "REVIVAL": "517385d3-6111-475d-b80e-1a83b23e7aad",
                "YULON": "1f659edd-16ce-4899-ab1d-2ba9b1611288",
                "CHI_JI": "82cdb567-8a7a-437b-934c-d407596754d2"
            },
            "BRM": {}
        },
        "HUNTER": {
            "MM": {},
            "SV": {},
            "BM": {}
        }
    }
}
